interface DmModalFooterProps {
    onCancel: () => void;
    cancelLabel?: string;
    primaryLabel: string;
    pendingLabel: string;
    onPrimary: () => void;
    isPending: boolean;
    primaryDisabled?: boolean;
}

export function DmModalFooter({
    onCancel,
    cancelLabel = 'Cancel',
    primaryLabel,
    pendingLabel,
    onPrimary,
    isPending,
    primaryDisabled = false
}: DmModalFooterProps) {
    return (
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex items-center justify-end gap-2.5 shrink-0">
            <button
                type="button"
                onClick={onCancel}
                disabled={isPending}
                className="text-sm font-semibold text-gray-500 hover:text-gray-900 px-3 h-10 disabled:opacity-50"
            >
                {cancelLabel}
            </button>
            <button
                type="button"
                disabled={isPending || primaryDisabled}
                onClick={onPrimary}
                className="bg-black text-white font-semibold px-5 h-10 rounded-xl text-sm hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
                {isPending && (
                    <span className="h-3.5 w-3.5 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                )}
                {isPending ? pendingLabel : primaryLabel}
            </button>
        </div>
    );
}
